import {useEffect, useState} from "react"
import axios, {AxiosError} from "axios";
import t from "../locales/translation";
import Package from "../models/Package";
import PackageTypes from "./PackageTypes";
import {PaymentWidgetProps} from "../models/PropsInterface";
import PaymentWidgetSkeletonShape from "./PaymentWidgetSkeletonShape";
import SuccessProcess from "./SuccessProcess";


const PaymentWidget = (props: PaymentWidgetProps): JSX.Element => {

    /*-----------------------------
     *           STATES
     * ----------------------------*/
    const [packages, setPackages] = useState<any>([])
    const [bundles, setBundles] = useState<any>([])
    const [label, setLabel] = useState<string>('')
    const [packagesConfig, setPackagesConfig] = useState<any>([])
    const [product, setProduct] = useState<any>([])
    const [load, setLoad] = useState<boolean>(false)
    const [isSuccessProcess,setIsSuccessProcess] = useState<boolean>(false)

    /*-----------------------------
     * REQUEST API FOR FETCHING THE
     *          PRODUCTS
     * ----------------------------*/
    const fetchProducts = async () => {
        return axios.post(`${props.api}/package/fetch/${props.modelId}`, {
            products: props.products
        }, {
            headers: {
                source: props.source,
                country: props.countryAbbreviation,
                [`enforce-language`]: props.language,
                [`Authorization`]: "Bearer " + props.token
            }
        })
    }

    /*-----------------------------
     *      GET PACKAGE CONFIG
     * ----------------------------*/
    const fetchPackageConfig = (packages: { [key: string]: Array<Package> }) => {

        const packageNames = Object.keys(packages);
        return packageNames.map((value, index) => {
            if (packageNames.length - 1 === index)
                return {'padding': 'right', 'name': value}
            else if (index === 0)
                return {'padding': 'left', 'name': value}
            return {'padding': 'mid', 'name': value}
        })
    }

    const fetchFirstProduct = (packages: { [key: string]: Array<Package> }) => {
        return ("shop" in packages) ? "shop" : ("Turbo" in packages) ? "Turbo" : Object.keys(packages)[0]
    }

    useEffect(() => {
        t.setLanguage(props.language)
    })

    useEffect(() => {
        setLoad(true)

        fetchProducts().then((response) => {
           let countryCode = 'jo'
            if (response.data.packages)
                 countryCode = Object.values(response.data.packages)[0][0]['countryCode']
            localStorage.setItem('countryCode', countryCode)
            const fetchedPackages = response.data.packages
            const fetchedBundles = response.data.bundles
            const firstProduct = fetchFirstProduct(fetchedPackages)
            setProduct(firstProduct)
            setPackages(fetchedPackages)
            setBundles(fetchedBundles)
            setLabel(
                props.language === "en" ? fetchedPackages[firstProduct][0].package['en'] :
                    fetchedPackages[firstProduct][0].package['ar']
            )

            setPackagesConfig(fetchPackageConfig(fetchedPackages))
            setLoad(false)
        }).catch((error: AxiosError) => {
            setLoad(false)
        })
    }, [])


    return (
        !isSuccessProcess ?
        !load ? <div className={`payment_wedget__box`} dir={props.language === 'en' ? 'ltr' : 'rtl'}>
            <div className={`payment_wedget__row`}>
                <p className={`payment_wedget__bold_font payment_wedget__font-size`}>{label}</p>
            </div>
            <PackageTypes setIsSuccessProcess={setIsSuccessProcess} domain={props.domain} pos_source={props.pos_source} referral_url={props.referral_url} api={props.api} token={props.token}
                          countryAbbreviation={props.countryAbbreviation} source={props.source} modelId={props.modelId}
                          packageConfig={packagesConfig} setLabel={setLabel} product={product}
                          bundles={bundles} packages={packages} language={props.language}/>
        </div> : <PaymentWidgetSkeletonShape></PaymentWidgetSkeletonShape>:<SuccessProcess/>
    )
}

export default PaymentWidget